export const SCA_INFO = {
  timestamp: '2025-12-22 14:52:33',
  responseName: 'SCAResponse',
  slResponseType: 'CONTENT_DATA',
  contentData: {
    pmEnvironment: {
      id: 1,
      name: 'Local',
      label: 'local',
    },
    code: 'CENTRO_BEAUTYCA_BY_STORE_BOOKINGS',
    name: 'StoreBookings',
    groupId: 'it.ynosit',
    artifactId: 'storebookingscentrobeautyca',
    version: '3.5.0',
    buildNumber: 12,
    lastBuildVersionBe: '3.5.0.12',
    lastBuildVersionFeWa: '3.5.0.11',
    isFeMaInMaintenance: false,
    scaPropertyList: [
      {
        key: 'url_privacy_policy',
        value: 'https://www.iubenda.com/privacy-policy/36458428',
        type: 'String',
      },
      {
        key: 'url_social.facebook.ios',
        value: 'fb://profile/113968301613487',
        type: 'String',
      },
      {
        key: 'url_social.facebook.android',
        value: 'fb://page/113968301613487',
        type: 'String',
      },
      {
        key: 'url_social.facebook.alternative_url',
        value: 'https://www.facebook.com/profile.php?id=100090315971540',
        type: 'String',
      },
      {
        key: 'url_social.instagram.ios',
        value: 'instagram://user?username=_.beautyca._',
        type: 'String',
      },
      {
        key: 'url_social.instagram.android',
        value: 'instagram://user?username=_.beautyca._',
        type: 'String',
      },
      {
        key: 'url_social.instagram.alternative_url',
        value: 'https://www.instagram.com/_.beautyca._/?igshid=ZDdkNTZiNTM%3D',
        type: 'String',
      },
      {
        key: 'url_store.ios',
        value: 'itms-apps://itunes.apple.com/app/6446252016',
        type: 'String',
      },
      {
        key: 'url_store.android',
        value:
          'https://play.google.com/store/apps/details?id=it.ynosit.storebookings.centrobeautyca',
        type: 'String',
      },
      {
        key: 'enabled.modules.fidelity_points',
        value: 'true',
        type: 'String',
      },
      {
        key: 'maps_pin.name',
        value: 'Shop',
        type: 'String',
      },
      {
        key: 'maps_pin.description',
        value: 'Shop',
        type: 'String',
      },
      {
        key: 'url_backend',
        value: 'https://dev.ynosit.it:1999',
        type: 'String',
      },
    ],
  },
  scaCredentials: {
    refreshToken:
      'eyJhbGciOiJIUzI1NiJ9.eyJJRF9TQ0FfQUNDT1VOVCI6MSwiaWF0IjoxNzY2NDExNTUzLCJzdWIiOiJZbm9zaXRzcmwiLCJpc3MiOiJZbm9zaXRzcmwiLCJleHAiOjE3NjY0MTkwNTN9.WtJk-6znES2puW8bRdvcJjOPaOT5GE2sk7A2pGhykXI',
  },
  path: 'https://prod.ynosit.it:1993/sonytools-0.0.0.0/pmFrontendProperties/api/v1/findByCodeAndEnv',
};
